export const environment = {
  production: false,
  base_url:  'https://swm-test-api.brainabove.net/api/v1/',
  environmentName: 'swm-test',
  headerName: 'Srinagar - ',
  loginLogo: 'smc_logo.png',
  citizen_base_url:  'https://swm-test-api.brainabove.net/citizen/api/v1/',
  ulb_id : 2,
  recaptcha_site_key: '6LefQJgrAAAAAIl_U4pEmAHUYM9Z3DA02Ht46OOm'
};